<template>
  <div>
    <a-spin :spinning="spinning">
      <a-row>
        <a-col :span="22">
          <!-- 基础信息 -->
          <BasicInfo :bizWebId="bizWebId" :housePic="housePic" :intentLeaseInfo="intentLeaseInfo" :houseBaseInfo="houseBaseInfo"></BasicInfo>
          <!-- 基础信息 -->
          <div
            style="
              display: flex;
              justify-content: center; /* 水平居中 */
              align-items: center; /* 垂直居中 */
            "
          >
            <a-card
              class="detail-card"
              style="width: 92%"
              :bordered="false"
              :headStyle="{ backgroundColor: '#fafafa' }"
              :bodyStyle="{ backgroundColor: '#fafafa' }"
            >
              <div class="detail-content">
                <!-- 房源概况 -->
                <HouseInfo id="houseInfo" :intentLeaseInfo="intentLeaseInfo" :houseBaseInfo="houseBaseInfo"></HouseInfo>
                <!-- 位置周边 -->
                <Location id="location" :intentLeaseInfo="intentLeaseInfo" :houseBaseInfo="houseBaseInfo" :bidInfoLoaded="bidInfoLoaded"></Location>
                <!-- 租金 -->
                <Rent id="rent" :intentLeaseInfo="intentLeaseInfo"></Rent>
                <!-- 租期 -->
                <TenancyTerm id="tenancyTerm" :intentLeaseInfo="intentLeaseInfo"></TenancyTerm>
                <!-- 招租条件与承租方资格条件 -->
                <Qualification id="qualification" :intentLeaseInfo="intentLeaseInfo" :houseBaseInfo="houseBaseInfo"></Qualification>
                <!-- 招租公告其他事项 -->
                <OtherInfo id="otherInfo" :intentLeaseInfo="intentLeaseInfo"></OtherInfo>
                <!-- 附件 -->
                <Attachments id="attachments"></Attachments>
              </div>
            </a-card>
          </div>
        </a-col>
        <a-col :span="2">
          <a-affix :offset-top="120">
            <div class="anchor-card">
              <div class="anchor-card-title">页面导航</div>

              <a-anchor
                :affix="false"
                class="page-anchor"
                :offset-top="anchorOffset"
                :target-offset="anchorOffset"
                :bounds="30"
              >
                <a-anchor-link href="#houseInfo" title="房源概况" />
                <a-anchor-link href="#location" title="位置周边" />
                <a-anchor-link href="#rent" title="租金" />
                <a-anchor-link href="#tenancyTerm" title="租期" />
                <a-anchor-link href="#qualification" title="资格条件" />
                <a-anchor-link href="#otherInfo" title="招租其他事项" />
                <a-anchor-link href="#attachments" title="附件" />
              </a-anchor>
            </div>
          </a-affix>
        </a-col>
      </a-row>
    </a-spin>

    <a-back-top />
  </div>
</template>
<script>
import { getIntentLease } from "@/api/publicInfo/PublicInfo.js";
import BasicInfo from "./detail/BasicInfo.vue";
import HouseInfo from "./detail/HouseInfo.vue";
import Location from "./detail/Location.vue";
import Rent from "./detail/Rent.vue"
import TenancyTerm from "./detail/TenancyTerm.vue"
import Qualification from "./detail/Qualification.vue";
import OtherInfo from "./detail/OtherInfo.vue";
import Attachments from "./detail/Attachments.vue";
export default {
  components: {
    BasicInfo,
    HouseInfo,
    Location,
    Rent,
    TenancyTerm,
    Qualification,
    OtherInfo,
    Attachments,
  },
  props: ["bizWebId","bizType"],
  data() {
    return {
      spinning:true,
      intentLeaseInfo:{

      },
      houseBaseInfo:{
      },
      housePic: [],
      //判断接口是否调用成功，默认是false,当初始化成功后改为ture,为了确保地图渲染
      bidInfoLoaded: false,
      // 锚点相关
      anchorOffset: 120,
    };
  },
  mounted() {
    console.log(this.bizWebId)

    this.listResource();

    this.anchorOffset = window.innerHeight / 2;
  },

  methods: {
    listResource() {
      this.spinning = true
      // this.table.loading = true;
      getIntentLease({
        intentLeaseId: this.bizWebId,
      }).then((res) => {
        // this.table.data = res.data ? [res.data.baseInfo] : [];
        // this.table.loading = false;

        // 将房源信息赋值给form，后续模块适用
        if (res.data && res.data.intentLeaseInfo) {
          const result = res.data.intentLeaseInfo;
          this.intentLeaseInfo = result
          // this.form.rentCount = result.leaseArea;
          // this.form.rentalUse = result.leaseUseType;
          // this.form.rentalUseDesc = result.leaseUse;
          // this.form.rentalStatus = result.houseStatus;
          // this.form.leaseTermExpireTime = result.leaseExpireTime;
          // this.form.rentalStatusOtherDesc = result.housingStatusOtherDesc;

          // if (result && result.lng && result.lat) {
          //   this.asset = {
          //     lng: result.lng,
          //     lat: result.lat,
          //   };

          //   this.defaultLocation = {
          //     lng: result.lng,
          //     lat: result.lat,
          //   };

          //   this.form.longitude = result.lng;
          //   this.form.dimension = result.lat;
          // }
          
        }
        if (res.data && res.data.houseBaseInfo) {
          const result = res.data.houseBaseInfo;
          this.houseBaseInfo = result
          // this.form.rentCount = result.leaseArea;
          // this.form.rentalUse = result.leaseUseType;
          // this.form.rentalUseDesc = result.leaseUse;
          // this.form.rentalStatus = result.houseStatus;
          // this.form.leaseTermExpireTime = result.leaseExpireTime;
          // this.form.rentalStatusOtherDesc = result.housingStatusOtherDesc;

          // if (result && result.lng && result.lat) {
          //   this.asset = {
          //     lng: result.lng,
          //     lat: result.lat,
          //   };

          //   this.defaultLocation = {
          //     lng: result.lng,
          //     lat: result.lat,
          //   };

          //   this.form.longitude = result.lng;
          //   this.form.dimension = result.lat;
          // }
          
        }
        this.housePic.push(
            ...res.data.housingCover,
            ...res.data.housingPicture
          );
        //接口调用完成
        this.bidInfoLoaded = true;
        this.spinning = false
      });
    },
  },
};
</script>

<style lang="less" scoped>
#container {
  border-radius: 4px;
  padding: 0;
  margin: 0;
  width: 100%;
  height: 700px;
}

.amap-logo {
  display: none;
  opacity: 0 !important;
}

.amap-copyright {
  opacity: 0;
}

.anchor-card {
  background: #ffffff;
  border: 1px solid #e8edf3;
  border-radius: 10px;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.04);
  padding: 10px 0;
  overflow: hidden;
}

.anchor-card-title {
  padding: 0 16px 10px;
  font-size: 14px;
  font-weight: 600;
  color: #262626;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 6px;
}

.page-anchor {
  padding: 4px 0 8px;
  background: transparent;
}

.page-anchor /deep/ .ant-anchor-wrapper {
  background: transparent !important;
}

.page-anchor /deep/ .ant-anchor {
  padding-left: 0;
}

.page-anchor /deep/ .ant-anchor-ink {
  left: 0;
}

.page-anchor /deep/ .ant-anchor-ink::before {
  width: 2px;
  background-color: #d9e7ff;
}

.page-anchor /deep/ .ant-anchor-ink-ball {
  display: none;
}

.page-anchor /deep/ .ant-anchor-link {
  padding: 0;
}

.page-anchor /deep/ .ant-anchor-link-title {
  display: block;
  height: 38px;
  line-height: 38px;
  padding: 0 16px 0 18px;
  font-size: 14px;
  color: #595959;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.2s ease;
  border-left: 2px solid transparent;
}

.page-anchor /deep/ .ant-anchor-link-title:hover {
  color: #1677ff;
  background: #f5f9ff;
}

.page-anchor /deep/ .ant-anchor-link-active > .ant-anchor-link-title {
  color: #1677ff;
  font-weight: 600;
  background: #eef4ff;
  border-left: 2px solid #1677ff;
}
</style>
